import { List, Typography, Card } from 'antd';
import step1 from './Images_new/TikTok_ForYou_Final.jpeg';
import step2 from './Images_new/TikTok_ProfilePage_Final.jpeg';
import step3 from './Images_new/TikTok_Settings_Final.jpeg';
import step4 from './Images_new/TikTok_Account_Final.jpeg';
import step5 from './Images_new/TikTok_CopyData_Final.jpeg'
import step6 from './Images_new/TikTok_Select_Fileformat.PNG';
import step7 from './Images_new/TikTok_JSON.PNG'
import step8 from './Images_new/TikTok_RequestData_Final.PNG';
import step9 from './Images_new/TikTok_DownloadResult_Final.PNG';
import './Request.css';

const { Text, Link, Title } = Typography;

const data = [
    {
        title: <Text strong={true}>Step 1</Text>,
        image: step1,
        description: 'Navigate to your profile page by pressing the "Profile" button at the bottom right of your screen.'
    },
    {
        title: <Text strong={true}>Step 2</Text>,
        image: step2,
        description: 'Press the button with the three horizontal bars at the top right of your screen.'
    },
    {
        title: <Text strong={true}>Step 3</Text>,
        image: step3,
        description: 'Press the "Settings and privacy" button in the popped up menu.'
    },
    {
        title: <Text strong={true}>Step 4</Text>,
        image: step4,
        description: 'Press the "Account" button in the Settings and privacy menu.'
    },
    {
        title: <Text strong={true}>Step 5</Text>,
        image: step5,
        description: 'Press the "Download your data" button to open the data download page.'
    },
    {
        title: <Text strong={true}>Step 6</Text>,
        image: step6,
        description: 'Press the "Select file format" button to change the file format to JSON.'
    },
    {
        title: <Text strong={true}>Step 7</Text>,
        image: step7,
        description: 'Select "JSON" and press the "Done" button.'
    },
    {
        title: <Text strong={true}>Step 8</Text>,
        image: step8,
        description: 'Press the "Request data" button to submit your request.'
    },
    {
        title: <Text strong={true}>Step 9</Text>,
        image: step9,
        description: <div><Text>Your data will become ready after a few days and you will be able to download it under the "Download data" tab. Once you have your JSON file, proceed to the </Text>
            <Link href="/donate" target="_blank">
                Data Donation page
            </Link>
            <Text> on this site to submit your data.</Text></div>
    },
];

export const TikTokRequest = () => {
    return (
        <div>
            <Title>How to Request Your TikTok Data</Title>
            <List grid={{ gutter: 16, column: Math.floor((window.innerWidth) / 260) }}
                dataSource={data}
                renderItem={item => (
                    <List.Item>
                        <Card title={item.title} cover={<img className="RequestCardImageMobile" src={item.image} />} >{item.description}</Card>
                    </List.Item>
                )} />
        </div>
    );
}

export default TikTokRequest;